import { Navigate, Outlet } from 'react-router-dom'

import {
  EngagementSurveysRootPageDocument,
  type EngagementSurveysRootPageQuery,
} from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import CollectionsBootstrap from 'modules/engagement_surveys/lib/CollectionsBootstrap'
import PageLoading from 'modules/layout/components/Page/Loading'

import { Upsell } from './Upsell'

export default function RootPage() {
  const { navigation } = useNavigation()
  const { company } = useCurrentSession()
  const { data, loading } = useQuery(EngagementSurveysRootPageDocument, {
    variables: {
      companyId: company.id,
    },
  })

  const canManageSurveys = data?.surveys._policies.sidebarSeeSmartSurveysSubLevelItem.can
  const upsellFlowEnabled = hasFeature(data, 'engagement_upsell_flow')

  if (loading) {
    return <PageLoading />
  }

  if (!canManageSurveys) {
    if (!upsellFlowEnabled) {
      return <Navigate to={navigation.discover.marketplaceModules.fullPath()} />
    }

    return <Upsell />
  }

  return (
    <CollectionsBootstrap>
      <Outlet />
    </CollectionsBootstrap>
  )
}

function hasFeature(data: EngagementSurveysRootPageQuery | undefined, featureName: string) {
  if (!data) {
    return false
  }

  return (
    data?.features.featuresConnection.nodes.some(
      (feature) => feature.name === featureName && feature.enabled
    ) ?? false
  )
}
